import { render } from "./SelectionTestDialog.vue?vue&type=template&id=4e611977"
import script from "./SelectionTestDialog.vue?vue&type=script&lang=js"
export * from "./SelectionTestDialog.vue?vue&type=script&lang=js"

import "./SelectionTestDialog.vue?vue&type=style&index=0&id=4e611977&lang=css"

import exportComponent from "/Users/macbookpro/Herd/hris-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__